<header class="sf-header">
  <h1>{{ 'bookings.title' | transloco }}</h1>
</header>

<div class="booking">
  @if (booking) {
    <div class="sf-section booking__section">
      <h3 class="booking__section-title">{{ 'bookings.customer.title' | transloco }}</h3>
      <table>
        <tr class="booking__section-info">
          <td>
            <i class="fa-solid fa-id-card"></i>
          </td>
          <td>
            <p class="booking__section-info-label">{{ 'bookings.customer.name' | transloco }}</p>
          </td>
          <td>
            <p>
              @if (booking.customer.firstname || booking.customer.lastname) {
                <span>
                  {{ booking.customer.firstname }} {{ booking.customer.lastname }}
                </span>
              }
              @if (!booking.customer.firstname && !booking.customer.lastname) {
                <span>-</span>
              }
            </p>
          </td>
        </tr>
        <tr class="booking__section-info">
          <td>
            <i class="fa-solid fa-envelope"></i>
          </td>
          <td>
            <p class="booking__section-info-label">{{ 'bookings.customer.email' | transloco }}</p>
          </td>
          <td>
            <p>{{ booking.customer.email }}</p>
          </td>
        </tr>
      </table>
    </div>
  }

  @if (booking) {
    <div class="booking__section-side-by-side">
      <div class="sf-section booking__section">
        <h3 class="booking__section-title">{{ 'bookings.details.title' | transloco }}</h3>
        <table>
          <tr class="booking__section-info">
            <td>
              <i class="fa-solid fa-calendar-week"></i>
            </td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.date.title' | transloco }}</p>
            </td>
            <td>
              <p>{{ booking.datetime.toJSDate() | date: 'd MMMM y, HH:mm' }}</p>
            </td>
          </tr>
          <tr class="booking__section-info">
            <td>
              <i class="fa-regular fa-circle"></i>
            </td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.status.title' | transloco }}</p>
            </td>
            <td>
              <div class="status status--{{booking.status}}">
                <p>{{ ('bookings.status.' + booking.status) | transloco }}</p>
              </div>
            </td>
          </tr>
          <tr class="booking__section-info">
            <td>
              <i class="fa-solid fa-note-sticky"></i>
            </td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.note.title' | transloco }}</p>
            </td>
            <td>
              <p class="booking__section-note">{{booking.note ? ('"' + booking.note + '"') : '-'}}</p>
            </td>
          </tr>
        </table>
      </div>

      <div class="sf-section booking__section">
        <h3 class="booking__section-title">{{ 'bookings.pricing.title' | transloco }}</h3>
        <table>
        <tr class="booking__section-info">
          <td>
            <i class="fa-solid fa-wallet"></i>
          </td>
          <td>
            <p class="booking__section-info-label">{{ 'bookings.pricing.publicPrice' | transloco }}</p>
          </td>
          <td>
            <p>{{ booking.publicPrice|currency:'EUR' }}</p>
          </td>
        </tr>
        @if (booking.depositAmount !== null && booking.depositAmount !== undefined) {
          <tr class="booking__section-info booking__section-info--nested">
            <td></td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.pricing.deposit' | transloco }}</p>
            </td>
            <td>
              <div class="booking__breakdown-line">
                <p>{{ (booking.depositAmount / 100)|currency:'EUR' }}</p>
                <span class="booking__pill booking__pill--{{ booking.depositStatus || 'pending' }}">
                  {{ ('bookings.pricing.payment-status.' + (booking.depositStatus || 'pending')) | transloco }}
                </span>
              </div>
            </td>
          </tr>
          <tr class="booking__section-info booking__section-info--nested">
            <td></td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.pricing.balance' | transloco }}</p>
            </td>
            <td>
              <div class="booking__breakdown-line">
                <p>{{ ((booking.balanceAmount ?? 0) / 100)|currency:'EUR' }}</p>
                <span class="booking__pill booking__pill--{{ booking.balanceStatus || 'pending' }}">
                  {{ ('bookings.pricing.payment-status.' + (booking.balanceStatus || 'pending')) | transloco }}
                </span>
              </div>
            </td>
          </tr>
        }
        <tr class="booking__section-info">
          <td>
            <i class="fa-solid fa-receipt"></i>
          </td>
            <td>
              <p class="booking__section-info-label">{{ 'bookings.pricing.commission' | transloco }}</p>
            </td>
            <td>
              <p>{{ booking.commission|currency:'EUR' }}</p>
            </td>
          </tr>
          <tr class="booking__section-info">
            <td>
              <i class="fa-solid fa-camera-retro"></i>
            </td>
            <td>
              <p class="booking__section-info-label"><b>{{ 'bookings.pricing.photographer-part' | transloco }}</b></p>
            </td>
            <td>
              <p><b>{{ booking.price|currency:'EUR' }}</b></p>
            </td>
          </tr>
        </table>

        @if (booking.invoiceUrl !== null) {
          <a class="button button--primary button--bill-download" [href]="booking.invoiceUrl">
            {{ 'bookings.pricing.download' | transloco }}
            <i class="fa-solid fa-file-arrow-down"></i>
          </a>
        }
      </div>
    </div>
  }

  @if (booking) {
    <div class="sf-section booking__section">
      <h3 class="booking__section-title">{{ 'bookings.manage-status.title' | transloco }}</h3>
      <p class="booking__section-subtitle">{{ 'bookings.manage-status.subtitle' | transloco }}</p>
      <div class="booking__section-status">
        <div class="booking__section-status-item"
          [ngClass]="{'booking__section-status-item--done': isAccepted()}"
          >
          <div class="booking__section-status-item-icon">
            <i class="fa-solid fa-check"></i>
          </div>
          <h3>{{'bookings.manage-status.status.accepted.title'|transloco}}</h3>
          <p class="booking__section-status-item-description">{{'bookings.manage-status.status.accepted.description'|transloco}}</p>
          <button class="button button--full-width"
            [disabled]="!canAccept() || statusInProgress !== null"
            [class.button--loading]="statusInProgress === BookingStatus.accepted"
            (click)="changeBookingStatus(BookingStatus.accepted)"
            >
            {{'bookings.manage-status.status.accepted.label'|transloco}}
          </button>
        </div>
        <div class="booking__section-status-item"
          [ngClass]="{'booking__section-status-item--done': isShootingDone()}"
          >
          <div class="booking__section-status-item-icon">
            <i class="fa-solid fa-camera-retro"></i>
          </div>
          <h3>{{'bookings.manage-status.status.shoot.title'|transloco}}</h3>
          <p class="booking__section-status-item-description">{{'bookings.manage-status.status.shoot.description'|transloco}}</p>
          <button class="button button--full-width"
            [disabled]="!canMarkAsShootingDone() || statusInProgress !== null"
            [class.button--loading]="statusInProgress === BookingStatus.shooting_done"
            (click)="changeBookingStatus(BookingStatus.shooting_done)"
            >
            {{'bookings.manage-status.status.shoot.label'|transloco}}
          </button>
          @if (isShootingBlocked()) {
            <p class="booking__section-status-item-lock-inline">
              {{
                'bookings.manage-status.status.shoot.balance-lock.inline'
                  | transloco:{
                    date: (balanceRetryUnlockDate | date:'short'),
                    countdown: balanceRetryCountdown
                  }
              }}
              @if (balanceRetryErrorMessage) {
                <span>
                  {{ balanceRetryErrorMessage }}
                </span>
              }
              @else if (balanceRetryCountdown) {
                <span>
                  {{
                    'bookings.manage-status.status.shoot.balance-lock.countdown'
                      | transloco:{ countdown: balanceRetryCountdown }
                  }}
                </span>
              }
            </p>
          }
        </div>
        <div class="booking__section-status-item"
          [ngClass]="{'booking__section-status-item--done': isDone()}"
          >
          <div class="booking__section-status-item-icon">
            <i class="fa-solid fa-box"></i>
          </div>
          <h3>{{'bookings.manage-status.status.finished.title'|transloco}}</h3>
          <p class="booking__section-status-item-description">{{'bookings.manage-status.status.finished.description'|transloco}}</p>
          <button class="button button--full-width"
            [disabled]="!canMarkAsDone() || statusInProgress !== null"
            [class.button--loading]="statusInProgress === BookingStatus.done"
            (click)="changeBookingStatus(BookingStatus.done)"
            >
            {{'bookings.manage-status.status.finished.label'|transloco}}
          </button>
        </div>
      </div>
      @if (canShowCancelBanner()) {
        <div class="cancel-banner"
          >
          <div>
            <h3>{{'bookings.manage-status.status.cancel.title'|transloco}}</h3>
            <p>{{'bookings.manage-status.status.cancel.subtitle'|transloco}}</p>
          </div>
          <button class="button button--danger"
            [class.button--loading]="statusInProgress === BookingStatus.cancelled"
            [disabled]="statusInProgress !== null"
            (click)="changeBookingStatus(BookingStatus.cancelled)"
            >
            {{'bookings.manage-status.status.cancel.label'|transloco}}
          </button>
        </div>
      }
    </div>
  }

  @if (canShowPhotos()) {
    <div class="sf-section booking__section"
      >
      <div class="booking__section-title-container">
        <h3 class="booking__section-title">{{ 'bookings.booking.photos.title' | transloco }}</h3>
        @if (booking && booking.status !== BookingStatus.done) {
          <app-image-upload
            [label]="'bookings.booking.photos.upload'"
            [shouldCompress]="false"
            [maxNumberOfImages]="null"
            (batchReady)="onBatchReady($event)"
            class="app-image-up"
          ></app-image-upload>
        }
      </div>
      @if (booking && booking.status !== BookingStatus.done) {
        <div class="info">
          <div class="info__icon">
            <i class="fa-solid fa-circle-info"></i>
          </div>
          <p>{{ 'bookings.booking.photos.explanation' | transloco }}</p>
        </div>
      }
      @if (booking && booking.photos && booking.photos.length) {
        <div class="booking__section-photos booking__section-photos--list"
          >
          @for (photo of booking.photos; track photo) {
            <div class="booking__section-photos--list_item">
              @if (booking.status !== BookingStatus.done) {
                <button class="button button--danger button--square booking__section-photos--list_item-delete"
                  (click)="deleteImage(photo.id)"
                  >
                  <i class="fa-solid fa-trash-can"></i>
                </button>
              }
              @if (photo.url) {
                <div class="booking__section-photos--list_item-image">
                  <app-image
                    [src]="photo.url"
                    alt="Booking photo"
                    preset="card"
                    aspectRatio="1"
                    [sizes]="'250px'"
                    [width]="250"
                    [height]="250"
                  ></app-image>
                </div>
              }
            </div>
          }
        </div>
      }
      @if (booking && booking.photos && booking.photos.length === 0) {
        <div class="booking__section-photos--empty"
          >
          <i class="fa-solid fa-panorama booking__section-photos--empty-icon"></i>
          <h2 class="booking__section-photos--empty-title">{{'bookings.booking.photos.empty-state.title'|transloco}}</h2>
          <p class="booking__section-photos--empty-subtitle">{{'bookings.booking.photos.empty-state.content'|transloco}}</p>
        </div>
      }
    </div>
  }
</div>
